<template>
  <div class='svg-container svg-arrow'> 
    <svg viewBox="0 0 44.45 34">
      <path class="svg-inner" d="M31.5.5h-9s5.3,11,6.93,12H.5v9H29.43c-1.63,1-6.93,12-6.93,12h9s4.61-11,12.1-16.5h0C36.11,11.49,31.5.5,31.5.5Z"/>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'SvgArrow',
}
</script>
<style lang="sass">
@import '../assets/partials/vars'

.svg-arrow
  svg
    width: 100%
    .svg-inner
      fill: transparent
      stroke: $tertiary-color
      stroke-width: 1
      stroke-miterlimit: 10

</style>